import { Box, Grid } from "@mui/material";
import { DisplayName, Plans } from "schemas/payments";

interface Props {
  plan: Plans;
}

const PlanStats = ({ plan }: Props) => {
  if (
    ![Plans.PRO, Plans.PRO_YEARLY, Plans.VA, Plans.VA_YEARLY]?.includes(plan)
  ) {
    return <></>;
  }

  return (
    <Grid item xs={12}>
      👉 {DisplayName[plan]} users are{" "}
      <Box
        component="span"
        sx={{
          color: "green.main",
          fontWeight: 600,
          textDecoration: "underline",
          textDecorationThickness: "3px",
          textUnderlineOffset: "4px",
        }}
      >
        {plan === Plans.PRO || plan === Plans.PRO_YEARLY ? 11 : 33}x more likely
      </Box>{" "}
      to land a brand deal
    </Grid>
  );
};

export default PlanStats;
